module.exports = __webpack_public_path__ + "Icono_Login_256px.png";